/* CASELLO — casello means quality | main JS */
document.addEventListener('DOMContentLoaded', () => {

  /* ── NAV SCROLL ── */
  const nav = document.getElementById('navbar');
  if(nav){
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  /* ── SCROLL REVEAL ── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  const dropGrid = document.getElementById('dropGrid');
  if(dropGrid){
    dropGrid.querySelectorAll('.product-card').forEach((el, i) => {
      el.style.transitionDelay = (i * 0.08) + 's';
      io.observe(el);
    });
  }

  /* ── GENERIC SLIDER FACTORY ── */
  function makeSlider({ trackId, prevId, nextId, navId, dotClass }) {
    const track = document.getElementById(trackId);
    if(!track) return;
    const slides = track.querySelectorAll(':scope > *');
    const dots   = navId ? document.getElementById(navId)?.querySelectorAll('.' + dotClass) : null;
    let current  = 0;

    function slideWidth() {
      return slides[0].getBoundingClientRect().width + 3;
    }
    function goTo(i) {
      current = Math.max(0, Math.min(i, slides.length - 1));
      track.style.transform = `translateX(-${current * slideWidth()}px)`;
      if(dots) dots.forEach((d, j) => d.classList.toggle('active', j === current));
    }
    document.getElementById(prevId)?.addEventListener('click', () => goTo(current - 1));
    document.getElementById(nextId)?.addEventListener('click', () => goTo(current + 1));
    if(dots) dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

    let startX = 0;
    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive:true});
    track.addEventListener('touchend',   e => {
      const diff = startX - e.changedTouches[0].clientX;
      if(Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    });
  }

  makeSlider({ trackId:'feedTrack', prevId:'feedPrev', nextId:'feedNext', navId:'feedNav', dotClass:'feed-dot' });
  makeSlider({ trackId:'lookTrack', prevId:'lookPrev', nextId:'lookNext', navId:'lookNav', dotClass:'look-dot' });

  /* ── CURSOR GLOW (desktop only) ── */
  if(window.matchMedia('(hover: hover)').matches){
    const glow = document.createElement('div');
    glow.style.cssText = `
      position:fixed; width:300px; height:300px; border-radius:50%;
      background:radial-gradient(circle, rgba(8,8,8,0.04) 0%, transparent 70%);
      pointer-events:none; z-index:9999;
      transform:translate(-50%,-50%);
      transition:left .12s ease, top .12s ease;
    `;
    document.body.appendChild(glow);
    document.addEventListener('mousemove', e => {
      glow.style.left = e.clientX + 'px';
      glow.style.top  = e.clientY + 'px';
    });
  }

});
